var _excluded = ["itemCount", "onScroll", "onViewportChange", "rowHeight", "UNSAFE_className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { TableView as SpectrumTableView } from '@adobe/react-spectrum';
import { useCallback, useEffect, useRef, useState } from 'react';
import { extractSpectrumLastChildHTMLElement, useOnScrollRef } from '@deephaven/react-hooks';
import { EMPTY_FUNCTION } from '@deephaven/utils';
import cl from 'classnames';
import { useSpectrumThemeProvider } from "../../theme/index.js";
import "./TableViewWrapper.css";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Wraps a Spectrum TableView with consistent sizing and scroll handling.
 * Table data wrappers can provide windowed items while sharing the same
 * Spectrum integration.
 */
export function TableViewWrapper(props) {
  var _tableViewProps$densi;
  var _props$itemCount = props.itemCount,
    itemCount = _props$itemCount === void 0 ? 0 : _props$itemCount,
    _props$onScroll = props.onScroll,
    onScroll = _props$onScroll === void 0 ? EMPTY_FUNCTION : _props$onScroll,
    onViewportChange = props.onViewportChange,
    rowHeight = props.rowHeight,
    UNSAFE_className = props.UNSAFE_className,
    tableViewProps = _objectWithoutProperties(props, _excluded);
  var _useSpectrumThemeProv = useSpectrumThemeProvider(),
    scale = _useSpectrumThemeProv.scale;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    scrollElement = _useState2[0],
    setScrollElement = _useState2[1];

  // Ref so callback identity changes don't retrigger updateViewport or the effect
  var onViewportChangeRef = useRef(onViewportChange);
  onViewportChangeRef.current = onViewportChange;
  var lastRangeRef = useRef(null);
  var updateViewport = useCallback(element => {
    if (onViewportChangeRef.current == null || rowHeight == null || rowHeight <= 0 || itemCount <= 0) {
      return;
    }
    // Prefer the row height Spectrum actually laid out over the density/scale
    // constant: at max scroll the constant under-estimates the true row
    // height and collapses the reported range to the final row.
    var effectiveRowHeight = element.scrollHeight > 0 ? element.scrollHeight / itemCount : rowHeight;
    var top = Math.min(itemCount - 1, Math.max(0, Math.floor(element.scrollTop / effectiveRowHeight)));
    var visibleRowCount = Math.max(1, Math.ceil(element.clientHeight / effectiveRowHeight));
    var bottom = Math.max(top, Math.min(itemCount - 1, top + visibleRowCount));
    var last = lastRangeRef.current;
    if (last != null && last[0] === top && last[1] === bottom) {
      return;
    }
    lastRangeRef.current = [top, bottom];
    onViewportChangeRef.current(top, bottom);
  }, [itemCount, rowHeight]);
  var handleScroll = useCallback(event => {
    onScroll(event);
    updateViewport(event.target);
  }, [onScroll, updateViewport]);
  var scrollRef = useOnScrollRef(handleScroll, extractSpectrumLastChildHTMLElement);
  var tableViewRef = useCallback(ref => {
    scrollRef(ref);
    setScrollElement(extractSpectrumLastChildHTMLElement(ref));
  }, [scrollRef]);
  useEffect(() => {
    if (scrollElement == null) {
      return undefined;
    }
    lastRangeRef.current = null;
    updateViewport(scrollElement);
    var resizeObserver = new ResizeObserver(() => {
      updateViewport(scrollElement);
    });
    resizeObserver.observe(scrollElement);
    return () => {
      resizeObserver.disconnect();
    };
  }, [scrollElement, updateViewport]);
  return /*#__PURE__*/_jsx(SpectrumTableView, _objectSpread(_objectSpread({
    ref: tableViewRef
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, tableViewProps), {}, {
    UNSAFE_className: cl('dh-table-view-wrapper', "dh-table-view-wrapper-density-".concat((_tableViewProps$densi = tableViewProps.density) !== null && _tableViewProps$densi !== void 0 ? _tableViewProps$densi : 'regular'), "dh-table-view-wrapper-scale-".concat(scale), UNSAFE_className)
  }));
}
export default TableViewWrapper;
//# sourceMappingURL=TableViewWrapper.js.map